export const initialFormValues = {
  serviceGroupingFilter: ['Todos'] as string[],
  salesItemNameFilter: ['Todos'] as string[]
}
